/** The editor mode that Jupyter is currently operating in. */
export enum JupyterMode {
  COMMAND = "command",
  EDIT = "edit",
}

/** Indicates something that can go up or down. */
export enum VerticalDirection {
  UP = "UP",
  DOWN = "DOWN",
}

/** A list of all the Jupyter shortcuts we interact with. */
/** A list of all the Jupyter shortcuts we interact with. */
/** A list of all the Jupyter shortcuts we interact with. */
/** A list of all the Jupyter shortcuts we interact with. */
export enum JupyterShortcut {
  /**  Command: Insert cell above */
  A = "a",
  /**  Command: Insert cell below */
  B = "b",
  /** Command: Change cell to markdown */
  M = "m",
  /** Command: Copy selected cells */
  C = "c",
  /** Command: Open keyboard shortcuts modal. */
  H = "h",
  /** Command: Cut selected cells */
  X = "x",
  /** Command: Change cell to raw */
  R = "r",
  /**  Command: change cell to code */
  Y = "y",
  /** Command: Change cell to heading 1 */
  NUM_1 = "1",
  /** Command: Change cell to heading 2 */
  NUM_2 = "2",
  /** Command: Change cell to heading 3 */
  NUM_3 = "3",
  /** Command: Change cell to heading 4 */
  NUM_4 = "4",
  /** Command: Change cell to heading 5 */
  NUM_5 = "5",
  /** Command: Change cell to heading 6 */
  NUM_6 = "6",
  /** Command: Confirm restart kernel */
  NUM_0_0 = "0,0",
  /**
   * Command: Change cell to raw
   * Edit: Change to command mode
   */
  ESC = "esc",
  /** Command: Delete cells */
  D_D = "d,d",
  /** Command: Enter edit mode */
  ENTER = "enter",
  /** Edit: Ignore it says (???) */
  SHIFT = "shift",
  /** Command: Extend selection below */
  SHIFT_J = "shift-j",
  /** Command: Extend selection above */
  SHIFT_K = "shift-k",
  /** Command: Merge cells */
  SHIFT_M = "shift-m",
  /** Execute. */
  SHIFT_ENTER = "shift-enter",
  /** Execute all cells */
  CTRL_SHIFT_ALT_ENTER = "ctrl-shift-alt-enter",
  /** Command: Interrupt the kernel */
  I_I = "i,i",
  CTRL_M = "ctrl-m",
  CTRL_ENTER = "ctrl-enter",
  ALT_ENTER = "alt-enter",
  META_S = "meta-s",
  /** Edit: Open the command palette. */
  META_SHIFT_P = "meta-shift-p",
  /** Edit: Open the command palette */
  META_SHIFT_F = "meta-shift-f",
  CTRL_SHIFT_MINUS = "ctrl-shift-minus",
  /** Move cursor up a line */
  UP = "up",
  /** Move cursor down a line */
  DOWN = "down",
}
